import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
export class CodeBlockRendererRegistry {
    components = {};
    registerComponent(language, component) {
        this.components[language] = component;
    }
    getComponent(language) {
        return this.components[language];
    }
}
const Context = createContext(null);
/**
 * the compoennts must be memoized to avoid rerendering the provider unnecessarily
 * @param param0
 * @returns
 */
export function CodeBlockRendererProvider({ components, children }) {
    const registry = useMemo(() => {
        const registry = new CodeBlockRendererRegistry();
        for (const [language, component] of Object.entries(components)) {
            registry.registerComponent(language, component);
        }
        return registry;
    }, [components]);
    return (_jsx(_Fragment, { children: _jsx(Context.Provider, { value: registry, children: children }) }));
}
export function useCodeBlockRendererRegistry() {
    return useContext(Context);
}
export function useCodeBlockComponent(language) {
    const registry = useContext(Context);
    if (registry) {
        return registry.getComponent(language);
    }
    return undefined;
}
//# sourceMappingURL=CodeBlockRendering.js.map